﻿export class Corporativo {
    idCorporativo: number;
    clave: string;
    nombre: string;
    telefono: string;
    contacto: string;
    avisoPrivacidad: string = "";
    correoRecepcion: string;
}